import MasterLayout from "@/layouts/master";
export default [
	{
    path: "/informes",
    component: MasterLayout,
    children: [
      {
        path: "aportes",
        name: "informes.aportes",
        component: () => import("@/views/informes/aportes/index.vue")
      },
      {
        path: "afiliaciones",
        name: "informes.afiliaciones",
        component: () => import("@/views/informes/afiliaciones/index.vue")
      },
      {
        path: "comisiones",
        name: "informes.comisiones",
        component: () => import("@/views/informes/comisiones/index.vue")
      },
      {
        path: "egresos",
        name: "informes.egresos",
        component: () => import("@/views/informes/egresos/index.vue")
      },
      {
        path: "listados",
        name: "informes.listados",
        component: () => import("@/views/informes/listados/index.vue")
      },
    ]
  }
]